// eslint-disable-next-line no-restricted-imports
import {
  MutationInput_LegalClientController_SaveIncomeSources_Input_IncomeSources_Items as IncomeSourcesApi,
  MutationInput_LegalClientController_SaveIncomeSources_Input_FinancialSources_Items as FinancialSourcesApi,
  SaveLegalClientIncomeSourcesDto_Input,
} from 'api/generated/graphql';
import { LegalClientSaveSourcesOfIncomeParam } from 'api/types/params';

export const parseLegalClientSaveSourcesOfIncomeParam = (
  data: LegalClientSaveSourcesOfIncomeParam
): SaveLegalClientIncomeSourcesDto_Input => ({
  incomeSources: data.incomeSources.map((v) => IncomeSourcesApi[v]),
  otherIncomeSource: data.otherIncomeSource || null,
  financialSources: data.financialSources.map((v) => FinancialSourcesApi[v]),
  otherFinancialSource: data.otherFinancialSource || null,
  confirmationFileIds: data.fileIds,
});
